import { IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import { getTranslateByKey } from "@/main/services/utils";
import RenderTooltipMessage from "@/main/components/shared/renderTooltipMessage/renderTooltipMessage";

interface IQuoteItemPartNumberProps {
	quoteItemPartNumber?: string;
}

export default function ColumnQuoteItemPartNumber({ quoteItemPartNumber }: IQuoteItemPartNumberProps) {
	if (!quoteItemPartNumber) {
		return <></>;
	}

	return (
		<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
			<a
				href={`https://www.google.com/search?q=${encodeURIComponent(quoteItemPartNumber)}`}
				target="_blank"
				rel="noopener noreferrer"
				style={{
					color: "#1976d2",
					textDecoration: "underline",
					cursor: "pointer",
				}}
				title={getTranslateByKey("information.clickHereMoreInformation")}
			>
				{quoteItemPartNumber}
			</a>
			<RenderTooltipMessage tooltipMessage={getTranslateByKey("information.copyPartNumber")}>
				<IconButton
					size="small"
					onClick={(e) => {
						e.stopPropagation();
						navigator.clipboard.writeText(quoteItemPartNumber);
						toast.success(getTranslateByKey("information.copySuccess"));
					}}
					style={{ padding: 2 }}
				>
					<ContentCopyIcon fontSize="small" />
				</IconButton>
			</RenderTooltipMessage>
		</div>
	);
}
